export default __webpack_public_path__ + "static/media/MicrocontrollersImg.2ad0612f.jpg";